import * as ActionBase from "DistributedTaskControls/Common/Actions/Base";
import { PipelineDefinition, PipelineDefinitionFolder } from "PipelineWorkflow/Scripts/Common/Types";
import { DefinitionsActionHubKeys } from "PipelineWorkflow/Scripts/Definitions/Constants";
import { IDefinitionEntry } from "PipelineWorkflow/Scripts/Definitions/AllDefinitionsContent";
import { IPermissionCollection } from "PipelineWorkflow/Scripts/SharedComponents/Security/PermissionHelper";
import { DashboardGroupEntry } from "TFS/Dashboards/Contracts";
import { PinArgs } from "TFSUI/Dashboards/AddToDashboard";

export interface IDefinitionsActionPayload {
    releaseDefinitionsIds: number[];
}

export interface ISearchResultsActionPayload extends IDefinitionsActionPayload {
    isLoading: boolean;
    showSearchResults: boolean;    
}

export interface IFoldersActionPayload {
    folders: PipelineDefinitionFolder[];
}

export interface IFolderNamePayload {
    folderPath: string;
}

export interface IDefinitionDialogPayload {
    showDialog: boolean;
    definitionName: string;
    definitionId: number;
}

export class DefinitionsActionsHub extends ActionBase.ActionsHubBase {
    
    public static getKey(): string {
        return DefinitionsActionHubKeys.ActionHubKey_DefinitionsActionHub;
    }

    public initialize(): void {
        this._initializeFolders = new ActionBase.Action<IFoldersActionPayload>();
        this._updateFolderPermissions = new ActionBase.Action<IPermissionCollection>();
    }

    public get foldersInitialized(): ActionBase.Action<IFoldersActionPayload> {
        return this._initializeFolders;
    }

    public get updateFolderPermissions(): ActionBase.Action<IPermissionCollection>  {
        return this._updateFolderPermissions;
    }

    private _initializeFolders: ActionBase.Action<IFoldersActionPayload>;
    private _updateFolderPermissions: ActionBase.Action<IPermissionCollection>;
}